import { INPUT_TYPE } from "../../../constants/Constant";
import { INPUT_VIEW_DIRECTION } from "deskera-ui-library";

export const FORM_FIELDS = [
  {
    key: "category",
    columnCode: "category",
    icon: "",
    validation: null,
    isValid: true,
    name: "Expense Category",
    type: INPUT_TYPE.DROPDOWN,
    errMsg: null,
    direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
    required: true,
    readOnly: false,
    options: [],
    multiSelect: true,
    hasError: false,
    uivisible: true,
    validation:[
      {
        validator: "required",field: [
          {id: "category", name:"Expense Category"}
        ]
      }
    ],
    tooltipMsg:""
  }, {
    key: "categoryLimit",
    columnCode: "categoryLimit",
    options: [],
    icon: "",
    isValid: true,
    name: "Expense Category Limit",
    type: INPUT_TYPE.NUMBER,
    errMsg: null,
    direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
    required: true,
    readOnly: false,
    hasError: false,
    uivisible: true,
    dependentFields: ["oneTimeExpenseLimit", "totalMonthlyLimit", "totalYearlyLimit"],
    validation: [
      {
        validator: "required",field: [
          {id: "categoryLimit", name:"Expense Category Limit"}
        ]
      },
      {
        validator: "greaterThan", field: [
          { id: "oneTimeExpenseLimit", name: "One Time Expense Limit" },
          { id: "totalMonthlyLimit", name: "Total Monthly Limit" },
          { id: "totalYearlyLimit", name: "Total Yearly Limit" }
        ]
      }
    ],
    tooltipMsg:""
  }, {
    key: "oneTimeExpenseLimit",
    columnCode: "oneTimeExpenseLimit",
    options: [],
    icon: "",
    isValid: true,
    name: "One Time Expense Limit",
    type: INPUT_TYPE.NUMBER,
    errMsg: null,
    direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
    required: true,
    readOnly: false,
    hasError: false,
    uivisible: true,
    dependentFields: ["categoryLimit", "totalMonthlyLimit", "totalYearlyLimit"],
    validation: [
      {
        validator: "required",field: [
          {id: "oneTimeExpenseLimit", name:"One Time Expense Limit"}
        ]
      },
      {
        validator: "lessThan", field: [
          { id: "categoryLimit", name: "Expense Category Limit" },
          { id: "totalMonthlyLimit", name: "Total Monthly Limit" },
          { id: "totalYearlyLimit", name: "Total Yearly Limit" }
        ]
      }
    ],
    tooltipMsg:""
  }, {
    key: "totalMonthlyLimit",
    columnCode: "totalMonthlyLimit",
    options: null,
    icon: "",
    validation: null,
    isValid: true,
    name: "Total Expense Limit (Monthly)",
    type: INPUT_TYPE.NUMBER,
    errMsg: null,
    direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
    required: true,
    readOnly: false,
    hasError: false,
    uivisible: true,
    dependentFields: ["totalYearlyLimit", "oneTimeExpenseLimit", "categoryLimit"],
    validation: [
      {validator: "required",field: [
          {id: "totalMonthlyLimit", name:"Total Monthly Limit"}
        ]
      },
      {
        validator: "lessThan", field: [
          { id: "totalYearlyLimit", name: "Total Yearly Limit" },
          { id: "categoryLimit", name: "Expense Category Limit" }
        ]
      },
      { validator: "greaterThan", field: [{ id: "oneTimeExpenseLimit", name: "One Time Expense Limit" }] }
    ],
    tooltipMsg:""
  }, {
    key: "totalYearlyLimit",
    columnCode: "totalYearlyLimit",
    options: null,
    icon: "",
    validation: null,
    isValid: true,
    name: "Total Expense Limit (Yearly)",
    type: INPUT_TYPE.NUMBER,
    errMsg: null,
    direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
    required: true,
    readOnly: false,
    hasError: false,
    uivisible: true,
    dependentFields: ["totalMonthlyLimit", "oneTimeExpenseLimit", "categoryLimit"],
    validation: [
      {
        validator: "required",field: [
          {id: "totalYearlyLimit", name:"Total Yearly Limit"}
        ]
      },
      {
        validator: "greaterThan", field: [
          { id: "totalMonthlyLimit", name: "Total Monthly Limit" },
          { id: "oneTimeExpenseLimit", name: "One Time Expense Limit" }
        ]
      },
      {
        validator: "lessThan", field: [
          { id: "categoryLimit", name: "Expense Category Limit" },
        ]
      }
    ],
    tooltipMsg:""
  }
]